/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type { Roles, RolesInterface } from "../../contracts/Roles";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "AlreadyDisabledModule",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "AlreadyEnabledModule",
    type: "error",
  },
  {
    inputs: [],
    name: "ArraysDifferentLength",
    type: "error",
  },
  {
    inputs: [],
    name: "CalldataOutOfBounds",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "enum PermissionChecker.Status",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "info",
        type: "bytes32",
      },
    ],
    name: "ConditionViolation",
    type: "error",
  },
  {
    inputs: [],
    name: "FunctionSignatureTooShort",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "HashAlreadyConsumed",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "InvalidModule",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPageSize",
    type: "error",
  },
  {
    inputs: [],
    name: "MalformedMultiEntrypoint",
    type: "error",
  },
  {
    inputs: [],
    name: "ModuleTransactionFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "NoMembership",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "NotAuthorized",
    type: "error",
  },
  {
    inputs: [],
    name: "SetupModulesAlreadyCalled",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "AllowFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "AllowTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32[]",
        name: "roleKeys",
        type: "bytes32[]",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "AssignRoles",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousAvatar",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newAvatar",
        type: "address",
      },
    ],
    name: "AvatarSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "allowanceKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "consumed",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "newBalance",
        type: "uint128",
      },
    ],
    name: "ConsumeAllowance",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "DisabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "EnabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "ExecutionFromModuleFailure",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "ExecutionFromModuleSuccess",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "HashExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "HashInvalidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
    ],
    name: "RevokeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "RevokeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "initiator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "avatar",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "RolesModSetup",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "parent",
            type: "uint8",
          },
          {
            internalType: "enum AbiType",
            name: "paramType",
            type: "uint8",
          },
          {
            internalType: "enum Operator",
            name: "operator",
            type: "uint8",
          },
          {
            internalType: "bytes",
            name: "compValue",
            type: "bytes",
          },
        ],
        indexed: false,
        internalType: "struct ConditionFlat[]",
        name: "conditions",
        type: "tuple[]",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "ScopeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "ScopeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "allowanceKey",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "balance",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "maxRefill",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "refill",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "period",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "timestamp",
        type: "uint64",
      },
    ],
    name: "SetAllowance",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "defaultRoleKey",
        type: "bytes32",
      },
    ],
    name: "SetDefaultRole",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "contract ITransactionUnwrapper",
        name: "adapter",
        type: "address",
      },
    ],
    name: "SetUnwrapAdapter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousTarget",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newTarget",
        type: "address",
      },
    ],
    name: "TargetSet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "allowFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "allowTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "allowances",
    outputs: [
      {
        internalType: "uint128",
        name: "refill",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "maxRefill",
        type: "uint128",
      },
      {
        internalType: "uint64",
        name: "period",
        type: "uint64",
      },
      {
        internalType: "uint128",
        name: "balance",
        type: "uint128",
      },
      {
        internalType: "uint64",
        name: "timestamp",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "roleKeys",
        type: "bytes32[]",
      },
      {
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "assignRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "avatar",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "consumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "defaultRoles",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "prevModule",
        type: "address",
      },
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "disableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "enableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModule",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModuleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "returnData",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRole",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRoleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "returnData",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "start",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pageSize",
        type: "uint256",
      },
    ],
    name: "getModulesPaginated",
    outputs: [
      {
        internalType: "address[]",
        name: "array",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "next",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
    ],
    name: "invalidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_module",
        type: "address",
      },
    ],
    name: "isModuleEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
    ],
    name: "moduleTxHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
    ],
    name: "revokeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "revokeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "parent",
            type: "uint8",
          },
          {
            internalType: "enum AbiType",
            name: "paramType",
            type: "uint8",
          },
          {
            internalType: "enum Operator",
            name: "operator",
            type: "uint8",
          },
          {
            internalType: "bytes",
            name: "compValue",
            type: "bytes",
          },
        ],
        internalType: "struct ConditionFlat[]",
        name: "conditions",
        type: "tuple[]",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "scopeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        internalType: "uint128",
        name: "balance",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "maxRefill",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "refill",
        type: "uint128",
      },
      {
        internalType: "uint64",
        name: "period",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "timestamp",
        type: "uint64",
      },
    ],
    name: "setAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
    ],
    name: "setAvatar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "roleKey",
        type: "bytes32",
      },
    ],
    name: "setDefaultRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    name: "setTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        internalType: "contract ITransactionUnwrapper",
        name: "adapter",
        type: "address",
      },
    ],
    name: "setTransactionUnwrapper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "initParams",
        type: "bytes",
      },
    ],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "target",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "unwrappers",
    outputs: [
      {
        internalType: "contract ITransactionUnwrapper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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__$2cd9b773a3c3e0b461f7ad54b09f46e6ae$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$1416e18a31f8412bde5440018f19e21267$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";

type RolesConstructorParams =
  | [linkLibraryAddresses: RolesLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RolesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Roles__factory extends ContractFactory {
  constructor(...args: RolesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, Roles__factory.linkBytecode(linkLibraryAddresses), signer);
    }
  }

  static linkBytecode(linkLibraryAddresses: RolesLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$2cd9b773a3c3e0b461f7ad54b09f46e6ae\\$__", "g"),
      linkLibraryAddresses["contracts/Integrity.sol:Integrity"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$1416e18a31f8412bde5440018f19e21267\\$__", "g"),
      linkLibraryAddresses["contracts/packers/Packer.sol:Packer"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override getDeployTransaction(
    _owner: AddressLike,
    _avatar: AddressLike,
    _target: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _owner,
      _avatar,
      _target,
      overrides || {}
    );
  }
  override deploy(
    _owner: AddressLike,
    _avatar: AddressLike,
    _target: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(_owner, _avatar, _target, overrides || {}) as Promise<
      Roles & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Roles__factory {
    return super.connect(runner) as Roles__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RolesInterface {
    return new Interface(_abi) as RolesInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Roles {
    return new Contract(address, _abi, runner) as unknown as Roles;
  }
}

export interface RolesLibraryAddresses {
  ["contracts/Integrity.sol:Integrity"]: string;
  ["contracts/packers/Packer.sol:Packer"]: string;
}
